<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ restaurant.title }}</strong>
                    <RestaurantTableOrderBadge />
                </CCardHeader>
                <CCardBody>
                    <RestaurantsTabLinks />
                    <CRow class="pl-3 pb-3" />
                    <CForm>
                        <label>Краткое описание <span class='label' > * </span></label> 
                        <CTextarea            
                            v-model="restaurant.description"
                            placeholder="Укажите краткое описание (не более 255 символов)" />

                        <CRow v-if="restaurant.picture">
                            <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                            <CCol sm="9" class="col-form-label">
                                <CImg
                                    :src="pictureUrl"
                                    class="m2"
                                    width="200" />
                            </CCol>
                        </CRow>

                        <label>Изображение сервиса (мобильное приложение) <span class='label' > * </span></label>
                        <CInputFile
                            ref="picture"
                            horizontal
                            @change="selectPicture" />

                        <br><br>
                        <CRow v-if="restaurant.square_picture">
                            <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                            <CCol sm="9" class="col-form-label">
                                <CImg
                                    :src="squarePictureUrl"
                                    class="m2"
                                    width="100" />
                            </CCol>
                        </CRow>
                        <CInputFile
                            ref="picture"
                            label="Изображение для поиска"
                            horizontal
                            @change="selectSquarePicture" />

                        <CRow v-if="restaurant.delivery_picture">
                            <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                            <CCol sm="9" class="col-form-label">
                                <CImg
                                    :src="deliveryPictureUrl"
                                    class="m2"
                                    width="200" />
                            </CCol>
                        </CRow>
                        <CInputFile
                            ref="picture"
                            label="Изображение для доставки"
                            horizontal
                            @change="selectDeliveryPicture" />


                        <br><br>
                        <CRow v-if="restaurant.desktop_picture">
                            <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                            <CCol sm="9" class="col-form-label">
                                <CImg
                                    :src="desktopPictureUrl"
                                    class="m2"
                                    width="100" />
                            </CCol>
                        </CRow>
                        <CInputFile
                            ref="picture"
                            label="Изображение для десктопа (внутри сервиса)"
                            horizontal
                            @change="selectDesktopPicture" />

                        <CRow v-if="restaurant.desktop_picture_list">
                            <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                            <CCol sm="9" class="col-form-label">
                                <CImg
                                    :src="desktopPictureUrlInList"
                                    class="m2"
                                    width="100" />
                            </CCol>
                        </CRow>
                        <CInputFile
                            ref="picture"
                            label="Изображение для десктопа (список)"
                            horizontal
                            @change="selectDesktopPictureInList" />   

                        <PromoCovers
                            :entity-type="BUSINESS_TYPE.RESTAURANT"
                            :entity-type-id="restaurant.id"
                            :covers="restaurant.promoCovers"
                            @covers-update="fetch"
                        />
                        <label>Телефон <span class='label' > * </span></label>
                        <CInput v-model="restaurant.phone"/>

                        <CInput v-model="restaurant.open_at" label="Открывается в" />

                        <CInput v-model="restaurant.close_at" label="Закрывается в" />


                        <CInput
                            v-model="restaurant.address"
                            label="Адрес для доставки"
                            placeholder="Укажите адрес, которй будет показываться на странице доставки" />

                        <CInput
                            v-model="restaurant.min_price"
                            label="Минимальный заказ" />

                        <CInput
                            v-model="restaurant.min_price_pickup"
                            label="Минимальная сумма для самовывоза" />

                        <CInput
                            v-model.number="restaurant.weight_limit"
                            label="Ограничение по весу (грамм)" />
                        <CInput
                            v-if="restaurant.weight_limit && restaurant.weight_limit > 0"
                            v-model="restaurant.weight_limit_description"
                            label="Сообщение о превышении веса" />

                        <CRow>
                            <CCol>
                                <label>Время, необходимое на выполнение заказа (часы) <span class='label' > * </span></label>
                                <CInput
                                    v-model="restaurant.delay_time_hour"
                                    placeholder="часы"
                                />
                            </CCol>
                            <CCol>
                                <CInput
                                    v-model="restaurant.delay_time"
                                    label="Время, необходимое на выполнение заказа (минуты)"
                                    placeholder="минуты"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol>
                                <label>Время доставки (часы) <span class='label' > * </span></label>
                                <CInput
                                    v-model="restaurant.delivery_time_hour"
                                    placeholder="часы"
                                />
                            </CCol>
                            <CCol>
                                <CInput
                                    v-model="restaurant.delivery_time"
                                    label="Время доставки (минуты)"
                                    placeholder="минуты"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol>
                                <CInput
                                    v-model="restaurant.max_delivery_time_hour"
                                    label="Максимальное время доставки (часы)"
                                    placeholder="часы"
                                />
                            </CCol>
                            <CCol>
                                <CInput
                                    v-model="restaurant.max_delivery_time"
                                    label="Максимальное время доставки (минуты)"
                                    placeholder="минуты"
                                />
                            </CCol>
                        </CRow>
                        <TimeSlotsUpdate :time-slots="timeSlots" @set-timeSlots="setTimeSlots" />
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Калории за 100 г
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.calories_100g"
                                />
                            </CCol>
                        </CRow>



                        <CRow v-if="adminOnly">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Средний чек
                            </CCol>
                            <CCol>
                                <CSelect
                                    class="mb-3"
                                    placeholder="Средний чек..."
                                    :options="[{ value: 0, label: 'эконом' }, { value: 1, label: 'средний' }, { value: 2, label: 'премиум' }]"
                                    :value.sync="restaurant.average_bill" />
                            </CCol>
                        </CRow>
                        <!-- Лейблы -->
                        <CRow v-if="adminOnly">
                            <CCol 
                                tag="label" 
                                class="col-form-label">
                                Лейблы
                            </CCol>
                        </CRow>
                        <CRow v-if="adminOnly" style="margin-left: 50px">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Наш выбор
                            </CCol>
                            <CCol>
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.labels.choose"
                                />
                            </CCol>
                        </CRow>
                        <CRow v-if="adminOnly" style="margin-left: 50px">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Новогоднее
                            </CCol>
                            <CCol>
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.labels.newYear"
                                />
                            </CCol>
                        </CRow>
                        <CRow v-if="adminOnly" style="margin-left: 50px">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Дружба
                            </CCol>
                            <CCol>
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.labels.friendship"
                                />
                            </CCol>
                        </CRow>
                        <CRow v-if="adminOnly" style="margin-left: 50px">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Без глютена
                            </CCol>
                            <CCol>
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.labels.glutenFree"
                                />
                            </CCol>
                        </CRow>
                        <CRow v-if="adminOnly" style="margin-left: 50px">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Халяль
                            </CCol>
                            <CCol>
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.labels.halal"
                                />
                            </CCol>
                        </CRow>
                        <CRow v-if="adminOnly" style="margin-left: 50px">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Без мяса
                            </CCol>
                            <CCol>
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.labels.meatFree"
                                />
                            </CCol>
                        </CRow>
                        <CRow v-if="adminOnly" style="margin-left: 50px">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Новинка
                            </CCol>
                            <CCol>
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.labels.new"
                                />
                            </CCol>
                        </CRow>
                        <CRow v-if="adminOnly" style="margin-left: 50px">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Популярное
                            </CCol>
                            <CCol>
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.labels.popular"
                                />
                            </CCol>
                        </CRow>
                        <CRow v-if="adminOnly" style="margin-left: 50px">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Постное
                            </CCol>
                            <CCol>
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.labels.post"
                                />
                            </CCol>
                        </CRow>
                        <CRow v-if="adminOnly" style="margin-left: 50px">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Без сахара
                            </CCol>
                            <CCol>
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.labels.sugarFree"
                                />
                            </CCol>
                        </CRow>
                        <CRow v-if="adminOnly" style="margin-left: 50px">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Веган
                            </CCol>
                            <CCol>
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.labels.vegan"
                                />
                            </CCol>
                        </CRow>
                        <CRow v-if="adminOnly" style="margin-left: 50px">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Острое
                            </CCol>
                            <CCol>
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.labels.spicy"
                                />
                            </CCol>
                        </CRow>
                        <CRow v-if="adminOnly" style="margin-left: 50px">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Рекомендуем
                            </CCol>
                            <CCol>
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.labels.recommended"
                                />
                            </CCol>
                        </CRow>
                        <CRow v-if="adminOnly" style="margin-left: 50px">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Только в Mir City
                            </CCol>
                            <CCol>
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.labels.exclusive"
                                />
                            </CCol>
                        </CRow>

                        <!-- Старые Лейблы -->
                        <CRow v-if="adminOnly">
                            <CCol 
                                tag="label" 
                                class="col-form-label">
                                Старые Лейблы
                            </CCol>
                        </CRow>
                        <CRow 
                            v-if="adminOnly"
                            style="margin-left: 50px">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Новый сервис
                            </CCol>
                            <CCol>
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.is_new_label"
                                />
                            </CCol>
                        </CRow>
                        <CRow 
                            v-if="adminOnly"
                            style="margin-left: 50px">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Веган
                            </CCol>
                            <CCol>
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.vegan_label"
                                />
                            </CCol>
                        </CRow>
                        <CRow 
                            v-if="adminOnly"
                            style="margin-left: 50px">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Рекомендуем
                            </CCol>
                            <CCol>
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.verified_mircity_label"
                                />
                            </CCol>
                        </CRow>
                        <CRow 
                            v-if="adminOnly"
                            style="margin-left: 50px">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Блюдо в подарок
                            </CCol>
                            <CCol>
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="restaurant.dish_gift_label"
                                />
                            </CCol>
                        </CRow>
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save">Сохранить</CButton>
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack">Отмена</CButton>
                </CCardFooter>
            </CCard>
        </CCol>

        <CModal
            title="Подтверждение"
            color="danger"
            :show.sync="deleteModal"
            :footer="false">
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <p>
                        Вы действительно хотите удалить ресторан? Это действие
                        нельзя будет отменить.
                    </p>
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="deleteModal = false">Отмена</CButton>
                    <CButton
                        color="danger"
                        class="ml-3"
                        @click="deleteRestaurant">Удалить</CButton>
                </div>
            </template>
        </CModal>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import RestaurantsTabLinks from '@/components/RestaurantsTabLinks';
    import TimeSlotsUpdate from '@/components/TimeSlotsUpdate';
    import PromoCovers from '@/components/promo-covers/PromoCovers';
    import { translit } from '@/utils/translit';
    import { xssRegEx } from '@/utils/rules';
    import { BUSINESS_TYPE } from '@/utils/order';
    import moment from 'moment';

    export default {
        name: 'RestaurantEdit',

        components: {
            RestaurantsTabLinks,
            TimeSlotsUpdate,
            PromoCovers,
        },

        data() {
            return {
                schedule: undefined,
                timeSlots: undefined,
                restaurant: {
                    id: 0,
                    code: '',
                    title: '',
                    short_title: '',
                    alias: '',
                    delivery_terminal_id: '',
                    description: '',
                    address: '',
                    picture: '',
                    square_picture: '',
                    delivery_picture: '',
                    desktop_picture: '',
                    desktop_picture_list: '',
                    tower: 0,
                    open_at: '',
                    close_at: '',
                    extended_schedule: false,
                    min_price: 0,
                    min_price_pickup: 0,
                    weight_limit: 0,
                    weight_limit_description: '',
                    phone: '',
                    delay_time: 0,
                    delay_time_hour: 0,
                    delivery_time: 0,
                    delivery_time_hour: 0,
                    max_delivery_time: 0,
                    max_delivery_time_hour: 0,
                    enabled: true,
                    hide: false,
                    position: 0,
                    calories_100g: false,
                    time_cooking_request: false,

                    labels: {
                        choose: false,
                        glutenFree: false,
                        halal: false,
                        meatFree: false,
                        new: false,
                        popular: false,
                        post: false,
                        sugarFree: false,
                        vegan: false,
                        spicy: false,
                        recommended: false,
                        newYear: false,
                        friendship: false,
                        exclusive: false,
                    },
                    average_bill: 0
                },
                towers: [],
                deliveryTerminals: [],
                selectedPicture: null,
                selectedSquarePicture: null,
                selectedDesktopPicture: null,
                selectedDesktopPictureInList: null,
                deleteModal: false,
                BUSINESS_TYPE
            };
        },

        computed: {
            pictureUrl() {
                if (this.restaurant.picture) {
                    return process.env.VUE_APP_STATIC_BASE_URL + '/' + this.restaurant.picture;
                }
                return '';
            },
            squarePictureUrl() {
                if (this.restaurant.square_picture) {
                    return process.env.VUE_APP_STATIC_BASE_URL + '/' + this.restaurant.square_picture;
                }
                return '';
            },
            desktopPictureUrl() {
                if (this.restaurant.desktop_picture) {
                    return process.env.VUE_APP_STATIC_BASE_URL + '/' + this.restaurant.desktop_picture;
                }
                return '';
            },

            desktopPictureUrlInList() {
                if (this.restaurant.desktop_picture_list) {
                    return process.env.VUE_APP_STATIC_BASE_URL + '/' + this.restaurant.desktop_picture_list;
                }
                return '';
            },

            deliveryPictureUrl() {
                if (this.restaurant.delivery_picture) {
                    return process.env.VUE_APP_STATIC_BASE_URL + '/' + this.restaurant.delivery_picture;
                }
                return '';
            },
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings'))
                    .is_business_admin;
            },
            computedCode() {
                if (!this.restaurant.code) {
                    this.restaurant.code = translit(this.restaurant.title ? this.restaurant.title : '');
                }
                return this.restaurant.code;
            },
        },

        async mounted() {
            await this.fetch();
        },

        methods: {
            setSchedule(schedule) {
                this.schedule = schedule;
            },

            setTimeSlots(timeSlots) {
                this.timeSlots = timeSlots;
            },

            selectPicture(FileList) {
                this.selectedPicture = FileList[0];
            },

            selectSquarePicture(FileList) {
                this.selectedSquarePicture = FileList[0];
            },

            selectDesktopPicture(FileList) {
                this.selectedDesktopPicture = FileList[0];
            },

            selectDesktopPictureInList(FileList) {
                this.selectedDesktopPictureInList = FileList[0];
            },

            selectDeliveryPicture(FileList) {
                this.selectedDeliveryPicture = FileList[0];
            },

            async fetch() {
                try {
                    const id = this.$route.params.id;
                    const restaurant = await Vue.axios.get('/restaurants/' + id);
                    this.restaurant = restaurant.data;
                    if (restaurant.data.schedule.length != 0) {
                        this.schedule = restaurant.data.schedule;
                    }
                    if (restaurant.data?.timeSlots?.length != 0) {
                        this.timeSlots = restaurant.data.timeSlots;
                    }
                } catch (error) {
                    this.$root.$emit('showError', `Ошибка загрузки данных. \n\n${error.response.data.error}`);
                }

                if (!this.towers.length) {
                    const towers = [{ value: null, label: 'Башня...' }];
                    const tows = await Vue.axios.get('/address')
                    tows.data.forEach(tower => {
                        towers.push({ value: tower.id, label: tower.name });
                    });
                    this.towers = towers;
                }

                if (this.restaurant.alias) {
                    try {
                        const deliveryTerminals = await Vue.axios.get(`/integration/iiko/delivery-terminals/${this.restaurant.alias}`)
                        this.deliveryTerminals = deliveryTerminals.data.deliveryTerminals.map(terminal => ({
                            label: `${terminal?.address} - ${terminal?.name}`,
                            value: terminal.deliveryTerminalId
                        }));
                    } catch (error) {
                        console.log(error);
                    }
                }

                if (!this.restaurant.labels) {
                    this.restaurant.labels = {
                        choose: false,
                        glutenFree: false,
                        halal: false,
                        meatFree: false,
                        new: false,
                        popular: false,
                        post: false,
                        sugarFree: false,
                        vegan: false,
                        spicy: false,
                        recommended: false,
                        newYear: false,
                        friendship: false,
                    }
                }
            },

            checkSlots(slots) {
                for (let i = 0; i < slots.length; i++) {
                    const checkStart = moment(slots[i].start_at, 'HH:mm');
                    const checkEnd = moment(slots[i].end_at, 'HH:mm');
                    const condidates = slots.filter(filterSlot => 
                        moment(filterSlot.start_at, 'HH:mm').isSameOrAfter(checkStart) &&
                        moment(filterSlot.end_at, 'HH:mm').isSameOrBefore(checkEnd)
                    );

                    if (condidates.length > 1) {
                        return `Слот на время с ${condidates[0].start_at} или до ${condidates[0].end_at} уже есть.`
                    }
                }
                return '';
            },

            async save() {
                if (!this.restaurant.description) {
                    this.$root.$emit('showError', 'Укажите краткое описание ресторана.');
                    return;
                }
                if (xssRegEx.test(this.restaurant.description)) {
                    this.$root.$emit('showError', 'Описание содержит недопустимые символы.')
                    return
                }
                if (!this.restaurant.phone) {
                    this.$root.$emit('showError', 'Укажите номер телефона ресторана.');
                    return;
                }
                if (
                    !this.restaurant.delivery_time &&
                    !this.restaurant.delivery_time_hour
                ) {
                    this.$root.$emit('showError', 'Укажите время доставки.');
                    return;
                }
                if (
                    this.restaurant.delivery_time == 0 &&
                    this.restaurant.delivery_time_hour == 0
                ) {
                    this.$root.$emit('showError', 'Укажите время доставки.');
                    return;
                }
                const noneDayOfWeek = [];
                for (const slot of this.restaurant.timeSlots) {
                    if (slot.day_of_week === null) {
                        noneDayOfWeek.push(slot)
                    }
                }
                const checkSlots = this.checkSlots(noneDayOfWeek);
                if (checkSlots) {
                    this.$root.$emit('showError', checkSlots);
                    return;
                }

                if(this.restaurant.delay_time === ''){
                    this.restaurant.delay_time = 0;
                }

                if(this.restaurant.delay_time_hour === ''){
                    this.restaurant.delay_time_hour = 0;
                }

                if(this.restaurant.delivery_time === ''){
                    this.restaurant.delivery_time = 0;
                }
                
                if(this.restaurant.delivery_time_hour === ''){
                    this.restaurant.delivery_time_hour = 0;
                }

                this.restaurant.extended_schedule = !!this.restaurant.extended_schedule;
                this.restaurant.schedule = this.schedule;
                this.restaurant.timeSlots = this.timeSlots;

                try {
                    let formData = new FormData();

                    if (this.selectedSquarePicture) {
                        formData.append('file', this.selectedSquarePicture);
                        const squarePictureName = await Vue.axios.post('/files/upload', formData);
                        this.restaurant.square_picture = squarePictureName.data.filename;
                    }

                    if (this.selectedDesktopPicture) {
                        formData = new FormData();
                        formData.append('file', this.selectedDesktopPicture);
                        const desktopPictureName = await Vue.axios.post('/files/upload', formData);
                        this.restaurant.desktop_picture = desktopPictureName.data.filename;
                    }

                    if (this.selectedDesktopPictureInList) {
                        formData = new FormData();
                        formData.append('file', this.selectedDesktopPictureInList);
                        const desktopPictureName = await Vue.axios.post('/files/upload', formData);
                        this.restaurant.desktop_picture_list = desktopPictureName.data.filename;
                    }

                    if (this.selectedDeliveryPicture) {
                        formData = new FormData();
                        formData.append('file', this.selectedDeliveryPicture);
                        const uploadPicture = await Vue.axios.post('/files/upload', formData);
                        this.restaurant.delivery_picture = uploadPicture.data.filename;
                    }

                    if (this.selectedPicture) {
                        formData = new FormData();
                        formData.append('file', this.selectedPicture);
                        const uploadPicture = await Vue.axios.post('/files/upload', formData);
                        this.restaurant.picture = uploadPicture.data.filename;
                    }
                    this.restaurant.delay_time = this.restaurant.delay_time ? +this.restaurant.delay_time : 0;
                    this.restaurant.delay_time_hour = this.restaurant.delay_time_hour ? +this.restaurant.delay_time_hour : 0;
                    this.restaurant.delivery_time = this.restaurant.delivery_time ? +this.restaurant.delivery_time : 0;
                    this.restaurant.delivery_time_hour = this.restaurant.delivery_time_hour ? +this.restaurant.delivery_time_hour : 0;
                    this.restaurant.min_price = this.restaurant.min_price ? +this.restaurant.min_price : 0;
                    this.restaurant.min_price_pickup = this.restaurant.min_price_pickup ? +this.restaurant.min_price_pickup : 0;
                    this.restaurant.weight_limit = this.restaurant.weight_limit ? +this.restaurant.weight_limit : 0;
                    this.restaurant.max_delivery_time = +this.restaurant.max_delivery_time ? +this.restaurant.max_delivery_time : null;
                    this.restaurant.max_delivery_time_hour = +this.restaurant.max_delivery_time_hour ? +this.restaurant.max_delivery_time_hour : null;
                    this.restaurant.hide = !!this.restaurant.hide;
                    
                    await Vue.axios.post('/restaurants/update/' + this.$route.params.id, this.restaurant);

                    this.goBack();
                } catch (error) {
                    this.$root.$emit('showError', `Ошибка сохранения. \n\n${error.response.data.error}`);
                }
            },

            deleteRestaurant() {
                Vue.axios
                    .delete('/restaurants/' + this.restaurant.id)
                    .then(resp => {
                        this.$router.push({ path: '/restaurants' });
                    })
                    .catch(err => {
                        this.$root.$emit('showError', `Ошибка удаления. \n\n${err.response.data.error}`);
                    });
            },

            goBack() {
                this.$router.push({
                    path: '/restaurants/' + this.$route.params.id,
                });
            },
        },
    };
</script>
<style scoped lang="scss">
.label
    {
    color: red;
    font-size: 150%
    }



</style>